import { render, staticRenderFns } from "./AccessProfile.vue?vue&type=template&id=68b1aea7"
import script from "./AccessProfile.vue?vue&type=script&lang=js"
export * from "./AccessProfile.vue?vue&type=script&lang=js"
import style0 from "./AccessProfile.vue?vue&type=style&index=0&id=68b1aea7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports